var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sign',{ref:"editor",attrs:{"options":_vm.options,"propValue":_vm.propValue,"dataId":_vm.dataId,"validateArg":_vm.validateArg},on:{"click":_vm.clickHandle,"change":_vm.changeHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }